import { observable } from "mobx";
import { Type } from "class-transformer";
import AccountingDocumentCandidateApprovalResponse from "./accountingDocumentCandidateApprovalResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class AccountingDocumentCandidateDetailResponse {
  id!: string;

  @observable
  accountingTemplateId!: string;

  @observable
  sequenceName!: string;

  @observable
  @Type(() => Date)
  accountingDate!: Date;

  @observable
  accountingPeriod!: string;

  @observable
  creditSum!: number;

  @observable
  debitSum!: number;

  @observable
  documentHeaderDescription!: string;

  @observable
  chargeId?: string;

  @observable
  chargeOrderId?: string;

  @observable
  transferPaymentId?: string;

  @observable
  payGatePaymentId?: string;

  @observable
  @Type(() => AccountingDocumentCandidateApprovalResponse)
  approvals!: AccountingDocumentCandidateApprovalResponse[];
}
